// src/components/SelectedPhotosPage.js
import React, { useState, useEffect } from "react";
import footerImage from "./../../images/LOTCADEAUX.png";
import "./FooterHome.css";

const FooterHome = () => {
  return (
    <>
      <div className="footerImg">
        <img src={footerImage} />
      </div>
    </>
  );
};

export default FooterHome;
